var _templateObject = _taggedTemplateLiteralLoose(['\n  .reactGiphySearchbox-poweredByGiphy {\n    padding-top: 10px;\n    width: 100px;\n  }\n\n  .reactGiphySearchbox-poweredByGiphy img {\n    display: block;\n    width: 100%;\n  }\n'], ['\n  .reactGiphySearchbox-poweredByGiphy {\n    padding-top: 10px;\n    width: 100px;\n  }\n\n  .reactGiphySearchbox-poweredByGiphy img {\n    display: block;\n    width: 100%;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

/* eslint-disable import/prefer-default-export */
import { css } from '../../style';

export var styles = css(_templateObject);